import { notification } from "antd";
import {
  FETCH_AUDIT_LOGS_REQUEST,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_AUDIT_LOGS_FAILURE,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const fetchAuditLogs = (page, limit) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_AUDIT_LOGS_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiGet(
        `api/auditlogs?page=${page}&limit=${limit}`
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors du chargement des logs d'audit"
        );
      }

      dispatch({ type: FETCH_AUDIT_LOGS_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: FETCH_AUDIT_LOGS_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors du chargement des logs d'audit",
        duration: 5,
      });
    }
  };
};
